<template lang="pug">
div
  modal-assinatura(
    v-if="modal"
    @closeModal="closeModal()"
    titulo="Assinar documento"
    texto="Para realizar a assinatura do documento é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
    @callbackSucesso="callbackModalAssinatura"
  )

  divider.text-container(label="Assinar documento")

  validation-observer(ref='observer' tag='form')
    validation-provider(rules="required", v-slot="{ errors }")
      el-row.row
        el-col(:span="8").container-input
          app-label(label="Selecione o Responsável:", :required="true")
          el-select.input(
            filterable,
            :filter-method="filtrarResponsaveis",
            class="select",
            v-model="responsavel",
            placeholder="Selecione",
            value-key="id",
            name="Resposavel",
            :class="{'erro' : errors.length}",
            @paste.native="onPaste"
          )
            el-option(
              v-for="item in responsaveisFiltrados",
              :key="item.id",
              :label="item.usuario.pessoa.nomeRazaoSocial",
              :value="item"
            )
          span.help.erro {{ errors[0] }}

  visualizar-documentos(
    :documento="documentoAssinatura",
    :bytes="bytes"
  )

  .buttons
    el-button(
      type="default",
      @click="goToListagem",
      name="voltar"
    )
      span.center
        i.fa.fa-chevron-left
        b &nbsp Voltar

    el-button(
      type="primary",
      @click="openModal",
      name="assinar",
    )
      span.center
        i.fa.fa-pencil-alt
        b &nbsp Assinar documento

</template>

<script>
import Divider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import cloneDeep from 'lodash/cloneDeep'
import VisualizarDocumentos from '@/screens/assinatura/components/VisualizarDocumentos'
import ModalAssinatura from '@/components/ModalAssinatura'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

const DOCUMENTO_ASSINATURA_EMPTY = {
  nome: null,
  nomeOriginal: null,
  responsavel: {
    id: null,
    usuario: {
      pessoa: {
        nomeRazaoSocial: null
      }
    }
  },
  tipo: {
    nome: null
  },
  dataEnvio: null,
  dataAssinatura: null
}

export default {
  components: {
    Divider,
    AppLabel,
    VisualizarDocumentos,
    ModalAssinatura
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      documentoAssinatura: cloneDeep(DOCUMENTO_ASSINATURA_EMPTY),
      bytes: null,
      modal: false,
      responsaveis: [],
      responsaveisFiltrados: [],
      responsavel: null
    }
  },

  created () {
    try {
      const { id } = this.$route.query

      this.getResponsaveis(id)
        .then(response => {
          this.responsaveis = response
          this.responsaveisFiltrados = response
        })

      if (id) {
        this.findById(id).then(response => {
          if (response.dataAssinatura) {
            this.goToListagem()

            return
          }

          this.documentoAssinatura = response
          this.renderPDF()
        })
      }
    } catch (error) {
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        this.$messages.TITULO_ERROR,
        error.message
      )

      this.goToListagem()
    }
  },

  methods: {
    ...mapActions({
      downloadDocumento: 'documentoAssinatura/download',
      findById: 'documentoAssinatura/findById',
      assinar: 'documentoAssinatura/assinar',
      getResponsaveis: 'responsavel/getResponsaveisNaoAssinaram'
    }),

    filtrarResponsaveis (filterValue) {
      this.responsaveisFiltrados = this.responsaveis.filter(item => {
        const normalize = (text) => {
          return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        }
        return normalize(item.usuario.pessoa.nomeRazaoSocial).indexOf(normalize(filterValue)) > -1
      })
    },

    async renderPDF () {
      const bytes = await this.downloadDocumento({ fileKey: this.documentoAssinatura.fileKey, id: this.documentoAssinatura.id })
      this.bytes = bytes
    },

    goToListagem () {
      this.$router.go(-1)
    },

    async openModal () {
      const valido = await this.$refs.observer.validate()

      if (valido) {
        this.modal = true
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    },

    closeModal () {
      this.modal = false
    },

    async callbackModalAssinatura (senha) {
      try {
        await this.assinar({
          ids: [this.documentoAssinatura.id],
          password: senha,
          idAssinador: this.responsavel.id
        })

        this.closeModal()

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DOCUMENTOS_ASSINADOS_SUCESSO
        )

        this.goToListagem()
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
      }
    },

    onPaste (evt) {
      evt.preventDefault()
    }

  }
}

</script>

<style lang="scss" scoped>
.text-container >>> .label-divider {
  padding-top: 0px;
}

.container-input {
  padding-right: 20px;
}

.input {
  width: 100%;
}

.row {
  padding-left: 10px;
  padding-right: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/AssinaturaDocumento.vue